import { render, staticRenderFns } from "./ireferral.vue?vue&type=template&id=34836b52&"
import script from "./ireferral.vue?vue&type=script&lang=js&"
export * from "./ireferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports